import React from "react";

import { IconMpFreeShipping, Span } from "@catchoftheday/cg-components";

export const MarketplaceFreeShippingTag = () => (
  <Span
    display="inline-block"
    width="44px"
    height="27px"
    margin="3px 5px 6px 0"
  >
    <IconMpFreeShipping
      title="Free Shipping"
      aria-label="Free Shipping"
      color="green"
      width="100%"
      minWidth="30px"
    />
  </Span>
);
